





































































































































import Api from "@/api/Api";
import AppButton from "@/components/AppButton.vue";
import Vue from "vue";
import { Route } from "vue-router";

export default Vue.extend({
  components: { AppButton },
  methods: {
    formatCtr(ctr: number) {
      if (null === ctr) {
        return "--";
      }
      return Math.round(ctr * 10000) / 100;
    },
    async fetchReportMetrics(targetUrl: string, theMonth: string) {
      this.loading = true;
      this.reportMetrics = [];
      const params = {
        month: this.theMonth,
        url: targetUrl,
      };
      const res = await Api.singleton().call({
        method: "get",
        resource: "/api/adv/reports",
        query: params
      });
      this.reportMetrics = res;
      this.loading = false;
    },
    updateUrl() {
      this.$router.push({
        name: "AdministratorAdReportIndex",
        query: {
          url: this.newTargetUrl,
        },
      });
    },
    load() {
      this.targetUrl = this.newTargetUrl = "" + (this.$route.query["url"] || "");
      this.$nextTick(() => {
        this.fetchReportMetrics(this.targetUrl, this.theMonth);
      });
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   next((vm) => {
  //     vm.newTargetUrl = "" + to.query["url"];
  //     vm.load();
  //   });
  // },
  mounted() {
    this.load();
  },
  watch: {
    $route(to: Route, from: Route) {
      if (to.fullPath !== from.fullPath) {
        this.load();
      }
    }
  },
  computed: {
    theMonth(): string {
      const queryMonth = "" + (this.$route.query.month || "");
      return queryMonth.match(/^\d\d\d\d-\d\d$/)
        ? queryMonth
        : this.$formatter.dateHyphened(new Date()).substr(0, 7);
    },
    theMonthDate(): Date {
      const [year, month] = this.theMonth.split("-");
      const r = new Date(parseInt(year, 10), parseInt(month, 10) - 1, 1);
      return r;
    },
    prevMonth(): string | null {
      const d = new Date(this.theMonthDate.getTime());
      d.setMonth(this.theMonthDate.getMonth() - 1);
      if (d < new Date(2020, 11, 1)) {
        return null;
      }

      return d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2);
    },
    nextMonth(): string | null {
      const d = new Date(this.theMonthDate.getTime());
      d.setMonth(this.theMonthDate.getMonth() + 1);
      if (new Date() < d) {
        return null;
      }

      return d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2);
    },
  },
  data() {
    return {
      reportMetrics: [],
      page: 1,
      perPage: 50,
      defaultSortOrder: "id",
      sortField: "id",
      sortOrder: "desc",
      total: NaN,
      loading: true,
      targetUrl: "",
      newTargetUrl: "",
    };
  },
});
